runOnLoad "Users", [ "new", "create", "edit", "update" ], ->

  $userRole = $('[name="user[role]"]:last')
  $permissionsSection = $("div.permissions")
  $termsAndConditions = $(".terms-and-conditions")

  showOrHidePermissions = ->

    role = $userRole.val()

    if role == "standard"
      $permissionsSection.show()
    else
      $permissionsSection.hide()

    # Show or hide the Terms & Conditions fields.
    if role == "system_admin"
      $termsAndConditions.hide()
    else
      $termsAndConditions.show()

    # Show or hide the JavaScript controls.
    if role == "system_admin"
      $(".user-javascript-enabled").show().find(":input").removeAttr("disabled").trigger("change", { animate: false })
      $(".user-javascript-disabled").hide().find(":input").attr("disabled", "disabled")
    else
      $(".user-javascript-enabled").hide().find(":input").attr("disabled", "disabled")
      $(".user-javascript-disabled").show().find(":input").removeAttr("disabled")

  $userRole.change(showOrHidePermissions)
  showOrHidePermissions()

  $('.user-permission-list-check-all').click ->
    $('.user-permission-list-field input[type="checkbox"]').prop('checked', true)

  $('.user-permission-list-uncheck-all').click ->
    $('.user-permission-list-field input[type="checkbox"]').prop('checked', false)
